import type {Editor} from 'grapesjs';

export const CURRENT_VERSION_INDEX = 0;

export interface EmailMakerVersionHistoryPanelProps {
  editor: Editor;
  idEmailTemplate: string | null;
  previewVersion: (editor: Editor, jsonContent: string) => void;
  completeRestore: (editor: Editor) => Promise<void> | void;
  onExit: () => void;
  className?: string;
}
